import { RewardCard, RewardChip, FlashIcon } from '@repo/ui'
import { useClientSideTranslation } from 'src/services/i18n'
import { useGetCurrentLanguage } from 'src/store/game'

type Props = Readonly<{
  reward: string
  isMobile?: boolean
}>

export function BoosterItemWrapper({ reward, isMobile = false }: Props) {
  const { t } = useClientSideTranslation(useGetCurrentLanguage())

  const accentColor = 'blue'
  const icon = <FlashIcon className="w-[14px] h-[14px] drop-shadow-[0_0_2px_rgba(0,0,0,0.25)]" />

  if (isMobile) {
    return <RewardChip accentColor={accentColor} icon={icon} reward={reward} />
  }

  return <RewardCard accentColor={accentColor} icon={icon} label={t('booster')} reward={reward} />
}
